// extracted by mini-css-extract-plugin
export var container = "_pi-0";
export var dotAnimation = "_pi-2";
export var dotsLoading = "_pi-1";